/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { Modal, Button } from 'react-bootstrap'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Spinner from 'react-bootstrap/Spinner'

interface OverheadCreateProps {
	show: boolean;
	handleClose: any;
	id: number;
}

interface InitialState {
	idOverheads: number | null;
	overheadName: string;
}

const OverheadCreate: React.FC<OverheadCreateProps> = ({ show, handleClose, id }) => {

	const initialState: InitialState = {
		idOverheads: null,
		overheadName: '',
	};

	const [overhead, setOverhead] = useState(initialState);

	useEffect(() => {

		if (id === 0) {
			setOverhead({ idOverheads: null, overheadName: '' });
		} else {
			fetch(
				process.env.REACT_APP_API_URL + 'overheads/' + id,
				getRequestOptions()
			)
				.then((resp) => {
					return resp.json()
				})
				.then((resp) => {
					setOverhead({ idOverheads: resp.data.idOverheads, overheadName: resp.data.overheadName });
				})
				.catch((error) => {
					console.log(error, 'catch the hoop')
				})
		}

	}, [id]);

	const [isSubmitDisable, setSubmitDisable] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleChange = (e: any) => {
		setOverhead({ ...overhead, [e.target.name]: e.target.value });
	};

	const overheadSave = async (event: any) => {
		event.preventDefault()
		setSubmitDisable(true);
		setLoading(true);
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: "You want to " + (id === 0 ? "create" : "update") + " this Overhead?",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Submit it!',
		})
		if (confirm.value) {
			const requestOptions = postRequestOptions(overhead)
			let url = (id === 0) ? `${process.env.REACT_APP_API_URL}overheads/store` : `${process.env.REACT_APP_API_URL}overheads/update`
			try {
				let response = await fetch(
					url,
					requestOptions
				)
				let respData = await response.json()
				if (respData.success === true) {
					const successMsg = respData.successMessage
					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: successMsg,
					})
					handleClose(respData.success)
				} else {
					const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
					Swal.fire({
						icon: 'error',
						title: 'Error',
						html: errorsMessage,
					})
				}
				setSubmitDisable(false);
				setLoading(false);
			} catch (error) {
				console.log(error, 'catch the hoop')
				setSubmitDisable(false);
			}
		}
	}


	return (
		<Modal show={show} onHide={() => handleClose(false)} size="lg">
			<form onSubmit={overheadSave}>
				<Modal.Header closeButton>
					<Modal.Title>{id === 0 ? 'Create' : 'Edit'} Overhead</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row">
						<label htmlFor="overheadName" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Name <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<input type="text" name="overheadName" id="overheadName" value={overhead.overheadName} onChange={handleChange} className="form-control form-control-sm" autoComplete='off' />
						</div>
					</div>
					{/* <pre>{JSON.stringify(overhead, null, 2)}</pre> */}
				</Modal.Body>
				<Modal.Footer>

					<button type="submit" disabled={isSubmitDisable || loading} className="btn btn-sm btn-primary me-2">
						{loading &&
							<Spinner
								as="span"
								animation="grow"
								size="sm"
								role="status"
								aria-hidden="true"
							/>
						}
						<span>  Submit</span>
					</button>
					<Button variant='secondary' size="sm" onClick={() => handleClose(false)}>
						Close
					</Button>
				</Modal.Footer>
			</form>
		</Modal>
	)
}

export default OverheadCreate
